import React from 'react'
import ReactDOM from 'react-dom'

import App from './App'
import * as serviceWorker from './serviceWorker'

/** Broadcast up page size changes. If we are in an iframe, listeners can resize the iframe to fit.
   We query 20 times a second - be aware of possible performance implications and reduce interval frequency if required. */
const broadcastHeightChanges = () => {
    var body = document.getElementsByTagName('body')[0];
    var height;

    setInterval(() => {
        height = body.scrollHeight;
        var messageToSend = {
            type: 'heightChange',
            height: height,
            isMobile: true,
        };
        window.parent.postMessage(messageToSend, '*');
    }, 300);
};

broadcastHeightChanges();

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
